// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"41f5b4d2","510":"4865ad7d","777":"4914be5c"}[chunkId] + ".chunk.js";
};